import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServiceRouter } from '../core/http-service-router.service';
import { Config } from '../../config/config';
import { METHOD_TYPE } from '../../constants/service.constants';
import { BehaviorSubject, Observable } from 'rxjs';
import { Environment } from '../../config/environment';
import { MentorAppointments, MentorAppointment, CoachResponseHM } from '../../beans/health-mentor/health-mentor.beans';
import * as moment from 'moment';

@Injectable({
	providedIn: 'root',
})
export class HealthMentorService {

	private schedulerSearchDateSource = new BehaviorSubject<Date | null>(null);
	schedulerSearchDate$ :  Observable<Date>;

	private schedulerSearchCoachSource =  new BehaviorSubject<number>(-1);
	schedulerSearchCoach$  : Observable<number>;
	
	MAX_SLOTS_COUNT = 30;
	
	constructor(
		private http: HttpClient,
		private serviceRouter: ServiceRouter,
		private environment: Environment,
		private config: Config,
	) {
		this.schedulerSearchDate$ = this.schedulerSearchDateSource.asObservable();
		this.schedulerSearchCoach$ = this.schedulerSearchCoachSource.asObservable();
	}

	updateSchedulerSearchDateSource(date: Date | null): void {
		this.schedulerSearchDateSource.next(date);
	}

	updateSchedulerSearchCoachSource(coachId: number): void {
		this.schedulerSearchCoachSource.next(coachId);
	}

	bookAppointment(appointment: MentorAppointment): Observable<any> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().EPMS_PROXY_BASE_URL,
			this.config.url.healthMentorApi.bookAppointment,
			METHOD_TYPE.SECURED_POST,
			appointment
		);
	}

	rescheduleAppointment(appointment: MentorAppointment): Observable<any> {
		return this.serviceRouter
			.makeRequest(
				this.environment.getEnvironment().EPMS_PROXY_BASE_URL,
				this.config.url.healthMentorApi.rescheduleAppointment + `?new_appt_id=${appointment.id}`,
				METHOD_TYPE.SECURED_POST,
				appointment
			)
	}

	getMentorAppointments(): Observable<MentorAppointments> {
		const self = this;
		return self.serviceRouter.makeRequest(
			self.environment.getEnvironment().EPMS_PROXY_BASE_URL,
			self.config.url.healthMentorApi.appointments,
			METHOD_TYPE.SECURED_GET,
			''
		);
	}

	getPostExamEligibility(appointment) {
		let postExamEligibility = true;

			appointment.forEach(appt => {
				if (appt && appt.date) {
					const dateFormat = 'MM/DD/YYYY';
					const apptDate = moment(new Date(appt.date.split(' ')[0])).format(dateFormat);
					const curDate = moment(new Date()).format(dateFormat);
					/**
					 * If any one appointment has been confirmed, then eligibility flag should be turned to false
					 */
					if (appt.status === 'Confirmed') {
						if (moment(apptDate).isAfter(moment(curDate)) || moment(apptDate).isSame(moment(curDate))) {
							postExamEligibility = false;
							return;
						}
					}
				}
			});
			return postExamEligibility;
	}

	getCoaches(): Observable<CoachResponseHM> {
		const self = this;
		return self.serviceRouter.makeRequest(
			self.environment.getEnvironment().EPMS_PROXY_BASE_URL,
			this.config.url.healthMentorApi.getCoaches,
			METHOD_TYPE.SECURED_GET,
			''
		);
	}
	
	getTimeslots(apptType: any, onSiteLocationId: number, start: string, end: string, coachID?: number | undefined): Observable<any> {
		let params = new HttpParams()
			.set('appt_type', apptType)
			.set('onsite_location_id', onSiteLocationId)
			.set('start', start)
			.set('end', end)

		if(coachID && coachID > -1) {
			params = params.append('coach_id', coachID);
		}

		return this.serviceRouter
			.makeRequest(
				this.environment.getEnvironment().EPMS_PROXY_BASE_URL,
				this.config.url.healthMentorApi.getAppointmentSlots + `?${params.toString()}`,
				METHOD_TYPE.SECURED_GET,
				''
			);
	}

	getHealthMentorInfo(): Observable<any> {
		const self = this;
		return self.serviceRouter.makeRequest(
			self.environment.getEnvironment().EPMS_PROXY_BASE_URL,
			this.config.url.healthMentorApi.getHapInfo,
			METHOD_TYPE.SECURED_GET,
			''
		);
	}
}
